/**
 * Day and month names in the SHOP's language, from the platform's own locale data.
 *
 * The seller can type their own list in the block settings; when they have not, the fallback used to be the
 * French list carried by `section.day_names` — which, by contract, no other dictionary translates (it is the
 * seller's starting content). So an English shop showed « Lundi, Mardi… » under its delivery estimate. `Intl`
 * knows all twenty-six shop languages; the dictionary stays the last resort for a runtime without it.
 *
 * Monday first, to match the French list and `weekdaySkipSet()`.
 */
export function intlDayNames(locale, width) {
    try {
        const f = new Intl.DateTimeFormat(locale, { weekday: width, timeZone: 'UTC' });
        // 2024-01-01 is a Monday.
        return [0, 1, 2, 3, 4, 5, 6].map((i) => tidy(f.format(new Date(Date.UTC(2024, 0, 1 + i, 12)))));
    }
    catch {
        return null;
    }
}
export function intlMonthNames(locale, width) {
    try {
        const f = new Intl.DateTimeFormat(locale, { month: width, timeZone: 'UTC' });
        return Array.from({ length: 12 }, (_, m) => tidy(f.format(new Date(Date.UTC(2024, m, 15, 12)))));
    }
    catch {
        return null;
    }
}
/** « lun. » → « Lun » : the block's own lists are capitalised and unpunctuated, and a seller's override follows them. */
function tidy(name) {
    const s = name.replace(/\.$/, '');
    return s.charAt(0).toLocaleUpperCase() + s.slice(1);
}
//# sourceMappingURL=dateNames.js.map